import Vue from 'vue';
import { createToastInterface } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import '@/assets/scss/toastr-shim.scss';

const options = {
  position: 'top-center',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false,
  transition: 'Vue-Toastification__fade',
  toastClassName: 'toastr-shim-toast',
};

const toast = createToastInterface(options, Vue);

const positionClassMap = {
  'toast-top-right': 'top-right',
  'toast-top-left': 'top-left',
  'toast-top-center': 'top-center',
  'toast-bottom-right': 'bottom-right',
  'toast-bottom-left': 'bottom-left',
  'toast-bottom-center': 'bottom-center',
};

const normalizeOptions = customOptions => {
  if (!customOptions) return undefined;

  return {
    ...customOptions,
    timeout: customOptions.timeout || customOptions.timeOut,
    position: customOptions.position || positionClassMap[customOptions.positionClass],
  };
};

const renderMessage = message => {
  if (typeof message !== 'string') return message;

  return {
    render(createElement) {
      return createElement('div', {
        domProps: {
          innerHTML: message,
        },
      });
    },
  };
};

const showToast = (type, message, title, customOptions) => {
  const formattedMessage = title ? `<strong>${title}</strong><br>${message}` : message;
  return toast[type](renderMessage(formattedMessage), normalizeOptions(customOptions));
};

const toastr = {
  options,
  success: (message, title, customOptions) => showToast('success', message, title, customOptions),
  error: (message, title, customOptions) => showToast('error', message, title, customOptions),
  info: (message, title, customOptions) => showToast('info', message, title, customOptions),
  warning: (message, title, customOptions) => showToast('warning', message, title, customOptions),
  warn: (message, title, customOptions) => showToast('warning', message, title, customOptions),
  clear: toast.clear,
  remove: toast.clear,
};

window.toastr = toastr;

export const $toastr = (type, msg) => {
  toastr.remove();
  const toastType = type === 'warn' ? 'warning' : type;
  toastr[toastType](msg);
};

export { options };
export default toastr;
